const TYPE_BADGES = {
  client_message: { label: "Message", cls: "bg-blue-500/15 text-blue-700 border-blue-500/40" },
  client_login: { label: "Login", cls: "bg-slate-500/15 text-slate-700 border-slate-500/40" },
  referral_submitted: { label: "Referral", cls: "bg-emerald-500/15 text-emerald-700 border-emerald-500/40" },
  affiliate_referral_submitted: { label: "Referral", cls: "bg-emerald-500/15 text-emerald-700 border-emerald-500/40" },
  trust_click: { label: "Inquiry", cls: "bg-amber-500/15 text-amber-700 border-amber-500/40" },
  funding_click: { label: "Inquiry", cls: "bg-amber-500/15 text-amber-700 border-amber-500/40" },
  trust_request_submitted: { label: "Inquiry", cls: "bg-amber-500/15 text-amber-700 border-amber-500/40" },
  funding_application_submitted: { label: "Inquiry", cls: "bg-amber-500/15 text-amber-700 border-amber-500/40" },
  streak_reset: { label: "Alert", cls: "bg-red-500/15 text-red-700 border-red-500/40" },
  email_bounced: { label: "Bounced", cls: "bg-red-500/15 text-red-700 border-red-500/40" },
  datamoon_lead_captured: { label: "Lead Capture", cls: "bg-amber-500/15 text-amber-700 border-amber-500/40" },
  lead_reply_received: { label: "Lead Reply", cls: "bg-emerald-500/15 text-emerald-700 border-emerald-500/40" },
  trulli_deal_update: { label: "Deal Update", cls: "bg-blue-500/15 text-blue-700 border-blue-500/40" },
  rep_low_leads: { label: "Urgent", cls: "bg-red-600/20 text-red-500 border-red-600/50" },
  lead_package_purchased: { label: "Purchase", cls: "bg-emerald-500/15 text-emerald-700 border-emerald-500/40" },
  trust_intake_submission: { label: "Trust Intake", cls: "bg-amber-500/15 text-amber-700 border-amber-500/40" },
  low_leads_both_categories_admin: { label: "URGENT — Low Leads", cls: "bg-red-600/25 text-red-400 border-red-600/60 animate-pulse" },
  auto_assign_digest_admin: { label: "Auto-Assign Digest", cls: "bg-emerald-500/15 text-emerald-700 border-emerald-500/40" },
};

const DEFAULT_BADGE = { label: "System", cls: "bg-igc-gold/10 text-igc-goldText border-igc-gold/30" };

export function getNotificationBadge(type) {
  return TYPE_BADGES[type] || DEFAULT_BADGE;
}
